import { makeApiRequest } from "../services/api";
import { API_BASE_URL, API_ENDPOINTS } from "../config/api";

// Use development proxy server or fallback to production URL
const isDevelopment = process.env.NODE_ENV === "development";

// // Get token from localStorage
// export const getToken = () => {
//   return localStorage.getItem("authToken");
// };

// // Store token in localStorage
// export const setToken = (token) => {
//   if (token) {
//     localStorage.setItem("authToken", token);
//   } else {
//     localStorage.removeItem("authToken");
//   }
// };

// // Remove token and clear auth-related data
// export const logout = () => {
//   localStorage.removeItem("authToken");
//   // Clear any other auth-related storage items here
// };

// // Check if user is authenticated
// export const isAuthenticated = () => {
//   return !!getToken();
// };

// Store tokens in localStorage
export const setTokens = (accessToken, refreshToken) => {
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
};

// Remove tokens from localStorage
export const clearTokens = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
};

// Get tokens from localStorage
export const getTokens = () => {
  return {
    accessToken: localStorage.getItem("accessToken"),
    refreshToken: localStorage.getItem("refreshToken"),
  };
};

// Login function with enhanced error handling
export const login = async (username, password) => {
  try {
    // Create a clean config object for the fetch request
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ username, password }),
    };

    const response = await fetch(API_ENDPOINTS.LOGIN, config);

    const contentType = response.headers.get("content-type");

    // If response is not JSON, handle accordingly
    if (!contentType || !contentType.includes("application/json")) {
      const textResponse = await response.text();
      throw new Error(
        `Server didn't return JSON. Received content type: ${
          contentType || "undefined"
        }. Response status: ${response.status}`
      );
    }

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        errorData.detail || `Login failed with status ${response.status}`
      );
    }

    const data = await response.json();

    if (data.access && data.refresh) {
      setTokens(data.access, data.refresh);
      return true;
    }
    return false;
  } catch (error) {
    console.error("Login failed:", error.message);
    throw error;
  }
};

// Logout function with enhanced error handling
export const logout = async () => {
  try {
    const { refreshToken } = getTokens();

    if (!refreshToken) {
      // If no refresh token exists, just clear tokens
      clearTokens();
      return true;
    }

    // Send logout request to backend
    const response = await fetch(API_ENDPOINTS.LOGOUT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ refresh: refreshToken }),
    });

    // Clear tokens regardless of server response
    clearTokens();

    if (!response.ok) {
      console.warn("Server-side logout returned a non-OK status");
    }

    return true;
  } catch (error) {
    console.error("Logout error occurred");
    // Clear tokens anyway even if server-side logout fails
    clearTokens();
    throw error;
  }
};

// Check if user is authenticated
export const isAuthenticated = () => {
  const { accessToken } = getTokens();
  return !!accessToken;
};

// Update your API service to use the token from auth
export const getAuthHeader = () => {
  const { accessToken } = getTokens();
  return accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
};
